import Vue from "vue";
import { ICustomProperties } from "@microsoft/applicationinsights-core-js";

export const logEvent = (name: string, properties?: { [key: string]: ICustomProperties }): void => {
  Vue.$appInsights.trackEvent({ name: name }, properties);
};

export const logMetric = (name: string, average: number, properties?: { [key: string]: ICustomProperties }): void => {
  Vue.$appInsights.trackMetric({ name: name, average: average }, properties);
};

export const logException = (exception: Error, severityLevel?: number): void => {
  Vue.$appInsights.trackException({ exception: exception, severityLevel: severityLevel });
  console.error(exception);
};

export const logTrace = (message: string, properties?: { [key: string]: ICustomProperties }): void => {
  Vue.$appInsights.trackTrace({ message: message }, properties);
};
